import React from 'react'
import { Mutation } from "react-apollo";
import Form from "../components/form";
import { EDIT, GET } from "../../../queries/network";
import { ADD_EDIT_NETWORK_SITE, GET_BY_NETWORK } from "../../../queries/networkSite";
import { Query } from "react-apollo";

const Update = (props) => {
  return (
    <>
    <Mutation
      mutation={EDIT}
      update={(cache, { data: { updateNetwork } }) => {
        const { networks } = cache.readQuery({ query: GET });
        cache.writeQuery({
          query: GET,
          data: { networks: networks }
        });
      }}
      >
      {updateNetwork => (
        <Mutation mutation={ADD_EDIT_NETWORK_SITE} update={(store, { data: { createNetworkSite } }) => {}}>
        {createNetworkSite=> (
          <Query query={GET_BY_NETWORK} variables={{ network: props.id }} options={{ fetchPolicy:'network-only' }}>
          {({ loading, error, data }) => {
            if (loading) return "Loading...";
            if (error) return `Error! ${error.message}`;
            let mySites = [];
            data.networkSites.forEach(networkSite => {
              mySites.push(networkSite.site.id);
            });
            return (
            <Form query_f = {updateNetwork} query_networkSite={createNetworkSite} mySites={mySites} {...props} />
            );
          }}
        </Query>
        )}
        </Mutation>
      )}
    </Mutation>
    
    </>
  );
};

export default Update;